import Box from '@zenbusiness/zui/Box';
import Heading from '@zenbusiness/zui/Heading';
import LoadingButton from '@zenbusiness/zui/LoadingButton';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { FocusGrid, ContainerGrid } from '#client/components/Grid';
import useAstraProfileContext from '#client/hooks/useAstraProfileContext';
import useBreakpoints from '#client/hooks/useBreakpoints';
import useEnterSubmit from '#client/hooks/useEnterSubmit';
import useFormStep from '#client/hooks/useFormStep';
import useInstantBankingCard from '#client/hooks/useInstantBankingCard';
import useOpenAstraModal from '#client/hooks/useOpenAstraModal';

import { DialogContentStyled, Wrapper } from './DialogAndWrapper.styles';

import { MODAL_ACTION } from '../constants/instants';

export function AddDestinationCardForm() {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();
  const tryAgainButtonId = useEnterSubmit();
  const { createBankingCardForInstantFunding, loading } = useInstantBankingCard();
  const { cardList, hasAcceptedTerms, refreshAstraProfile } = useAstraProfileContext();
  const { getAndRedirectAstraUrl } = useOpenAstraModal();
  const { dispatchDepositData } = useFormStep();

  const handleTryAgain = async () => {
    const { error: createCardError } = await createBankingCardForInstantFunding();
    if (createCardError) {
      return;
    }

    // After create destination successfully, get the lasted astra list card
    refreshAstraProfile();

    // If astra account doesn't have transfer card, redirect to astra form
    if (hasAcceptedTerms === true && cardList && cardList.length === 0) {
      getAndRedirectAstraUrl();
      return;
    }

    // If not, go to enter amount screen
    dispatchDepositData({
      type: MODAL_ACTION.GO_TO_HOW_MUCH_FORM,
      payload: {
        isDisableBack: false
      }
    });
  };

  return (
    <DialogContentStyled role="form">
      <ContainerGrid>
        <FocusGrid>
          <Wrapper gap={{ xs: '32px', md: '40px' }}>
            <Stack
              alignItems="center"
              justifyContent="center"
            >
              <Box>
                <SharedAsset
                  alt=""
                  height={isDesktop ? 200 : 110}
                  src="/s2/vector/alert-green-iso.svg"
                  width={isDesktop ? 200 : 110}
                />
              </Box>
              <Stack
                gap="8px"
                mt={{ xs: '24px', md: '40px' }}
              >
                <Heading
                  align="center"
                  size="3xl"
                  weight="bold"
                >
                  There was an error setting up your account for Instant deposits
                </Heading>
                <Text
                  align="center"
                  color="tertiary"
                  size="lg"
                >
                  Your request could not be processed at this time, please try again.
                </Text>
              </Stack>
              <Stack mt={{ xs: '32px', md: '40px' }}>
                <LoadingButton
                  color="primary"
                  disabled={loading}
                  fullWidth
                  id={tryAgainButtonId}
                  loading={loading}
                  onClick={handleTryAgain}
                  size="large"
                  variant="contained"
                >
                  TRY AGAIN
                </LoadingButton>
              </Stack>
            </Stack>
          </Wrapper>
        </FocusGrid>
      </ContainerGrid>
    </DialogContentStyled>
  );
}
